export default "__VITE_ASSET__CPildnlB__"